export const useListProps = (id: string | undefined) => {
  return {
    path: `/shipment-service/parcels`,
    selectRowsEnabled: { enabled: false },
    actionBar: { enabled: false },
    pagination: { enabled: false },

    filters: {
      name: "parsels",
      preserve: false,

      list: [
        {
          fieldName: "shipmentId",
          hidden: true,
          value: id,
        },
      ],
    },
  };
};
